var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12322 0H11.8099L17.477 5.90705V17.3963C17.477 18.8356 16.3126 20 14.8783 20H5.12322C3.68394 20 2.51953 18.8356 2.51953 17.3963V2.60369C2.51951 1.16441 3.68392 0 5.12322 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8086 0V5.86207H17.4808L11.8086 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 14.9227V11.2695H6.97024C7.35505 11.2695 7.65991 11.3745 7.88979 11.5894C8.11967 11.7993 8.23463 12.0841 8.23463 12.4389C8.23463 12.7938 8.11967 13.0786 7.88979 13.2885C7.65991 13.5034 7.35505 13.6084 6.97024 13.6084H6.35055V14.9227H5.41602ZM6.35055 12.8138H6.8653C7.00522 12.8138 7.11517 12.7838 7.19014 12.7138C7.26509 12.6489 7.3051 12.5589 7.3051 12.439C7.3051 12.319 7.26512 12.2291 7.19014 12.1641C7.11519 12.0941 7.00524 12.0642 6.8653 12.0642H6.35055V12.8138ZM8.61941 14.9227V11.2695H9.91376C10.1686 11.2695 10.4085 11.3045 10.6334 11.3795C10.8583 11.4544 11.0632 11.5594 11.2431 11.7043C11.423 11.8442 11.5679 12.0341 11.6729 12.274C11.7728 12.5139 11.8278 12.7888 11.8278 13.0986C11.8278 13.4035 11.7728 13.6783 11.6729 13.9182C11.5679 14.1581 11.423 14.348 11.2431 14.4879C11.0632 14.6328 10.8583 14.7378 10.6334 14.8128C10.4085 14.8877 10.1686 14.9227 9.91376 14.9227H8.61941ZM9.53396 14.1281H9.80381C9.94874 14.1281 10.0837 14.1131 10.2086 14.0781C10.3285 14.0432 10.4435 13.9882 10.5534 13.9132C10.6584 13.8383 10.7433 13.7333 10.8033 13.5934C10.8633 13.4535 10.8933 13.2885 10.8933 13.0986C10.8933 12.9037 10.8633 12.7388 10.8033 12.5989C10.7433 12.459 10.6584 12.354 10.5534 12.279C10.4435 12.2041 10.3286 12.1491 10.2086 12.1141C10.0837 12.0792 9.94874 12.0641 9.80381 12.0641H9.53396V14.1281ZM12.2976 14.9227V11.2695H14.8963V12.0641H13.2321V12.6488H14.5614V13.4385H13.2321V14.9227H12.2976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0472767d16c319fda96a1eaa89e12e82.svg";
export { ForwardRef as ReactComponent };